import { Field, Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { Card, Col, Row, Form as BForm, Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import TextInput from "../../../../../components/formfields/InputField";
import { addHomeDataAction, getResources } from "../actions";

const ResourceSection = () => {
  const [resourceEdit, setResourceEdit] = useState<boolean>(false);
  const [resources, setResources] = useState([]);
  const resource_state = useSelector((state: any) => state?.home?.home_data);
  const dispatch = useDispatch();

  const resourceState = {
    resource_header: resource_state?.resource_header ? resource_state?.resource_header : "",
    resource_description: resource_state?.resource_description ? resource_state?.resource_description : "",
    resource_button: resource_state?.resource_button ? resource_state?.resource_button : "",
    resource_button_link: resource_state?.resource_button_link ? resource_state?.resource_button_link : "",
    resource_list1: resource_state?.resource_list1 ? resource_state?.resource_list1 : [],
    resource_list2: resource_state?.resource_list2 ? resource_state?.resource_list2 : [],
  };

  const handleResourceSubmit = (values: any) => {
    if ((!values.resource_button && values.resource_button_link) || (values.resource_button && !values.resource_button_link)) {
      toast.error("Please validate the form");
    } else {
      let resourceList1 = [];

      // Iterate through each object in the array and extract the "name" key
      for (let i = 0; i < values.resource_list1.length; i++) {
        resourceList1.push(values.resource_list1[i].id);
      }
      let resourceList2 = [];

      // Iterate through each object in the array and extract the "name" key
      for (let i = 0; i < values.resource_list2.length; i++) {
        resourceList2.push(values.resource_list2[i].id);
      }
      const data: any = {
        resource_header: values.resource_header,
        resource_description: values.resource_description,
        resource_button: values.resource_button,
        resource_button_link: values.resource_button_link,
        resource_list1: resourceList1,
        resource_list2: resourceList2,
      };
      // const form_data = new FormData();
      // form_data.append("id", "resource");
      // form_data.append("resource_header", values.resource_header);
      // form_data.append("resource_description", values.resource_description);
      // form_data.append("resource_button", values.resource_button);
      // form_data.append("resource_button_link", values.resource_button_link);
      // form_data.append("resource_list1", JSON.stringify(resourceList1));
      // form_data.append("resource_list2", JSON.stringify(resourceList2));
      dispatch(addHomeDataAction(data, setResourceEdit, "add-resource-section"));
      console.log("resource_values", values);
      setResourceEdit(false);
    }
  };

  useEffect(() => {
    dispatch(getResources("paginate=50", setResources));
  }, []);

  const handleSelect = (item: any, arr: any[], setArr: any, name: string) => {
    if (arr.map((el: any) => el.id).includes(item.id)) {
      const newArr = arr.filter((el: any) => el.id !== item.id);
      setArr(name, newArr);
    } else {
      setArr(name, [...arr, item]);
    }
  };

  const removeResource = (index: number, arr: any[], setArr: any, name: string) => {
    const newArr = [...arr];
    newArr.splice(index, 1);
    setArr(name, [...newArr]);
  };

  return (
    <Formik enableReinitialize initialValues={resourceState} onSubmit={handleResourceSubmit}>
      {({ values, handleChange, handleBlur, setFieldValue }) => {
        console.log("values.resource_list1,values.resource_list1", values.resource_list1);

        return (
          <>
            <Form>
              <Card>
                <Card.Header className="d-flex justify-content-between align-items-center">
                  <h6 className={`mb-0 fs-lg ${resourceEdit ? "editTitle" : ""}`}>Resource Section</h6>
                  {resourceEdit ? (
                    <button type="submit" className="btn btn-primary">
                      <i className="fa-regular fa-pen-to-square"></i> Save
                    </button>
                  ) : (
                    <span onClick={() => setResourceEdit(true)} className="btn btn-green">
                      <i className="fa-regular fa-pen-to-square"></i> Edit
                    </span>
                  )}
                </Card.Header>
                <Card.Body className="position-relative">
                  <div
                    className={`position-absolute w-100 h-100 start-0 top-0 zIndex-1 ${resourceEdit ? "d-none" : ""}`}
                    style={{ background: "rgba(255,255,255,0.5)", cursor: "not-allowed" }}
                  ></div>
                  <Row className="gy-3">
                    <Col xs={12}>
                      <label className="form-label">Header</label>
                      <Field
                        name="resource_header"
                        component={TextInput}
                        value={values.resource_header}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Header"
                        readOnly={!resourceEdit}
                        className={resourceEdit ? "editField" : ""}
                      />
                    </Col>
                    <Col xs={12}>
                      <label className="form-label">Header Description</label>
                      <Field
                        name="resource_description"
                        component={TextInput}
                        value={values.resource_description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Header Description"
                        readOnly={!resourceEdit}
                        className={resourceEdit ? "editField" : ""}
                        multiline
                      />
                    </Col>
                    <Col sm={4}>
                      <label className="form-label">Button</label>
                      <Field
                        name="resource_button"
                        component={TextInput}
                        value={values.resource_button}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Button"
                        readOnly={!resourceEdit}
                        className={resourceEdit ? "editField" : ""}
                      />
                      {!values.resource_button && values.resource_button_link ? <div className="errorMessage">Enter button text</div> : null}
                    </Col>
                    <Col sm={8}>
                      <label className="form-label">Button Link</label>
                      <Field
                        name="resource_button_link"
                        component={TextInput}
                        value={values.resource_button_link}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Button link"
                        readOnly={!resourceEdit}
                        className={resourceEdit ? "editField" : ""}
                      />
                      {values.resource_button && !values.resource_button_link ? <div className="errorMessage">Enter button Link</div> : null}
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
              <div className="position-relative">
                <div
                  className={`position-absolute w-100 h-100 start-0 top-0 zIndex-1 ${resourceEdit ? "d-none" : ""}`}
                  style={{ background: "rgba(255,255,255,0.5)", cursor: "not-allowed" }}
                ></div>
                <Card>
                  <Card.Header className="d-flex justify-content-between align-items-center">
                    <h6 className={`mb-0 fs-lg ${resourceEdit ? "editTitle" : ""}`}>Row 1</h6>
                  </Card.Header>
                  <Card.Body>
                    <label className="form-label">Resource</label>{" "}
                    <Dropdown className="select">
                      <Dropdown.Toggle variant="primary" id="dropdown-basic">
                        Select Resources
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="mt-0 overflow-auto" style={{ maxHeight: "200px" }}>
                        {resources.map((item: any, index: number) => {
                          return (
                            <BForm.Check
                              key={item.id}
                              type="checkbox"
                              id={`default-${index}`}
                              label={`${item?.name}`}
                              checked={
                                values.resource_list1.map((ele: any) => ele.id).includes(item.id) ||
                                values.resource_list2.map((ele: any) => ele.id).includes(item.id)
                              }
                              onClick={() => {
                                handleSelect(item, values.resource_list1, setFieldValue, "resource_list1");
                              }}
                              disabled={values.resource_list2.map((ele: any) => ele.id).includes(item.id)}
                            />
                          );
                        })}
                      </Dropdown.Menu>
                    </Dropdown>
                    {values.resource_list1.length ? (
                      <div className="d-flex flex-wrap gap-2 border p-3 rounded-3 mt-3">
                        {values.resource_list1.map((item: any, index: number) => {
                          return (
                            <div key={item.name} className="d-flex align-items-center border p-2 rounded-3">
                              <span className="fw-bold">{item.name}</span>
                              <i
                                className="fa-solid fa-xmark text-danger ms-2 cursor-pointer"
                                onClick={() => resourceEdit && removeResource(index, values.resource_list1, setFieldValue, "resource_list1")}
                              ></i>
                            </div>
                          );
                        })}
                      </div>
                    ) : null}
                  </Card.Body>
                </Card>
                <Card>
                  <Card.Header className="d-flex justify-content-between align-items-center">
                    <h6 className={`mb-0 fs-lg ${resourceEdit ? "editTitle" : ""}`}>Row 2</h6>
                  </Card.Header>
                  <Card.Body>
                    <label className="form-label">Resource</label>{" "}
                    <Dropdown className="select">
                      <Dropdown.Toggle variant="primary" id="dropdown-basic">
                        Select Resources
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="mt-0 overflow-auto" style={{ maxHeight: "200px" }}>
                        {resources.map((item: any, index: number) => {
                          return (
                            <BForm.Check
                              key={item.id}
                              type="checkbox"
                              id={`default2-${index}`}
                              label={`${item?.name}`}
                              checked={
                                values.resource_list2.map((ele: any) => ele.id).includes(item.id) ||
                                values.resource_list1.map((ele: any) => ele.id).includes(item.id)
                              }
                              onClick={() => {
                                handleSelect(item, values.resource_list2, setFieldValue, "resource_list2");
                              }}
                              disabled={values.resource_list1.map((ele: any) => ele.id).includes(item.id)}
                            />
                          );
                        })}
                      </Dropdown.Menu>
                    </Dropdown>
                    {values.resource_list2.length ? (
                      <div className="d-flex flex-wrap gap-2 border p-3 rounded-3 mt-3">
                        {values.resource_list2.map((item: any, index: number) => {
                          return (
                            <div key={item.id} className="d-flex align-items-center border p-2 rounded-3">
                              <span className="fw-bold">{item.name}</span>
                              <i
                                className="fa-solid fa-xmark text-danger ms-2 cursor-pointer"
                                onClick={() => resourceEdit && removeResource(index, values.resource_list2, setFieldValue, "resource_list2")}
                              ></i>
                            </div>
                          );
                        })}
                      </div>
                    ) : null}
                  </Card.Body>
                </Card>
              </div>
            </Form>
          </>
        );
      }}
    </Formik>
  );
};

export default ResourceSection;
